import { endOfSkippable } from "./end-of-skippable";

/** A spread in CODE position, at any depth: the parser cannot evaluate one. */
export function hasSpreadInCode(literal: string): boolean {
  for (let at = 0; at < literal.length; at += 1) {
    const skipped = endOfSkippable(literal, at);
    if (skipped !== at) {
      at = skipped;
      continue;
    }
    if (literal.startsWith("...", at)) return true;
  }
  return false;
}
